var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTourEndIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 70.667,
    viewBox: "0 0 64 70.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff3d00;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        filter: url(#Pfad_355);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_355",
    x: 0,
    y: 0,
    width: 64,
    height: 70.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "place-map-marker",
    transform: "translate(12 11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1648",
    "data-name": "Gruppe 1648"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, -12, -11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_355-2",
    "data-name": "Pfad 355",
    className: "cls-1",
    d: "M20,0A19.917,19.917,0,0,0,0,20,19.813,19.813,0,0,0,14.889,39.333L20,46.667l5.111-7.333A19.813,19.813,0,0,0,40,20,19.917,19.917,0,0,0,20,0Z",
    transform: "translate(12 11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stop-standstill-white",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1154",
    "data-name": "Pfad 1154",
    className: "cls-2",
    d: "M0,0H24V24H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1155",
    "data-name": "Pfad 1155",
    className: "cls-3",
    d: "M6,6H18V18H6Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourEndIcon);
export default __webpack_public_path__ + "static/media/tour-end-icon.e96ebc33e38e02a990269b1845f74db9.svg";
export { ForwardRef as ReactComponent };